import { FC } from "react";
import { FiltersBar, SortersBar } from "../components";
import { useJourneyListingContext } from "../context/JourneyListingContext";
import { JourneyType, DataGroupType } from "src/Modules/Flights/constants";
import JourneyListContent from "../components/JourneyList/components/JourneyListContent/JourneyListContent";
import { MainSearch } from "src/Modules/Flights/Components";
import classNames from "classnames";
import CountdownTimerSlider from "@Components/CountdownTimerSlider/CountdownTimerSlider";
import Sticky from "src/components/Sticky";
const JourneyListingWeb: FC<{
  fullDataGroups: DataGroupType;
  filteredGroups: DataGroupType;
  journies: JourneyType[];
}> = ({ fullDataGroups, filteredGroups, journies }) => {
  const { isFetching, searchObject } = useJourneyListingContext();
  const hasJournies = isFetching || journies.length > 0;
  return (
    <Sticky
      className="bg-background-default"
      header={
        <div className="bg-background-default">
          <div className="bg-background-default p-3 shadow-md lg:px-4 xl:px-10">
            <MainSearch initialValues={searchObject} />
          </div>
          <div>
            <CountdownTimerSlider />
          </div>
        </div>
      }
      body={() => (
        <div className="flex gap-1 lg:px-4 xl:gap-4 xl:px-10">
          <div className={classNames("min-w-75 flex-1", "custom-scrollbar")}>
            <div className={"top-sticky-header sticky max-h-screen overflow-y-auto"}>
              <FiltersBar dataGroups={fullDataGroups} />
            </div>
          </div>
          <div className="flex-4 min-w-170 flex flex-col gap-6 p-4">
            {hasJournies && (
              <div className="bg-background-default top-sticky-header sticky z-10 -m-2 py-4">
                <div className="shadow-sm rounded-md">
                  <SortersBar dataGroups={filteredGroups} />
                </div>
              </div>
            )}
            <div>
              <JourneyListContent isFetching={isFetching} journies={journies} />
            </div>
          </div>
          <div className="flex-1"></div>
        </div>
      )}
    />
  );
};

export default JourneyListingWeb;
